// extracted by mini-css-extract-plugin
export default {"left-cc":"controlcentre_left-cc__93ujn","p-datatable":"controlcentre_p-datatable__cXLyr"};